import { render } from "./tim-kiem-chuyen-di.vue?vue&type=template&id=282556cc&scoped=true"
import script from "./tim-kiem-chuyen-di.vue?vue&type=script&lang=js"
export * from "./tim-kiem-chuyen-di.vue?vue&type=script&lang=js"

import "./tim-kiem-chuyen-di.vue?vue&type=style&index=0&id=282556cc&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282556cc"]])

export default __exports__